import React, { useCallback } from 'react';
import { makeStyles } from 'tss-react/mui';
import { isMobileBrowser } from '../../../environment/utils';
const useStyles = makeStyles()(theme => {
    return {
        container: {
            position: 'relative',
            backgroundColor: theme.palette.switchBackground,
            borderRadius: '12px',
            width: '40px',
            height: '24px',
            border: 0,
            outline: 0,
            cursor: 'pointer',
            transition: '.3s',
            display: 'inline-block',
            '&.disabled': {
                backgroundColor: theme.palette.switchBackground,
                cursor: 'default',
                '& .toggle': {
                    backgroundColor: theme.palette.switchToggleDisabled
                }
            },
            '&.is-mobile': {
                height: '32px',
                width: '50px',
                borderRadius: '32px'
            }
        },
        containerOn: {
            backgroundColor: theme.palette.switchBackgroundOn
        },
        toggle: {
            width: '16px',
            height: '16px',
            position: 'absolute',
            zIndex: 5,
            top: '4px',
            left: '4px',
            backgroundColor: theme.palette.switchToggle,
            borderRadius: '100%',
            transition: '.3s',
            '&.is-mobile': {
                width: '24px',
                height: '24px'
            }
        },
        toggleOn: {
            left: '20px',
            '&.is-mobile': {
                left: '22px'
            }
        },
        checkbox: {
            position: 'absolute',
            zIndex: 10,
            cursor: 'pointer',
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            opacity: 0,
            '&.focus-visible + .toggle-checkbox-ring': {
                outline: 0,
                boxShadow: `0px 0px 0px 2px ${theme.palette.switchFocus}`
            }
        },
        checkboxRing: {
            position: 'absolute',
            pointerEvents: 'none',
            zIndex: 6,
            left: 0,
            right: 0,
            top: 0,
            bottom: 0,
            width: '100%',
            height: '100%',
            borderRadius: '12px',
            '&.is-mobile': {
                borderRadius: '32px'
            }
        }
    };
});
const Switch = ({ className, id, checked, disabled, onChange }) => {
    const { classes: styles, cx } = useStyles();
    const isMobile = isMobileBrowser();
    const change = useCallback((e) => {
        onChange(e.target.checked);
    }, []);
    return (React.createElement("span", { className: cx('toggle-container', styles.container, checked && styles.containerOn, isMobile && 'is-mobile', disabled && 'disabled', className) },
        React.createElement("input", { type: 'checkbox', ...(id ? { id } : {}), checked: checked, className: styles.checkbox, disabled: disabled, onChange: change }),
        React.createElement("div", { className: cx('toggle-checkbox-ring', styles.checkboxRing, isMobile && 'is-mobile') }),
        React.createElement("div", { className: cx('toggle', styles.toggle, checked && styles.toggleOn, isMobile && 'is-mobile') })));
};
export default Switch;
